<template>
  <section
    class="expandable-keyfigure"
    :style="{ backgroundColor: content.backgroundColor || '#ffffff' }"
  >
    <div
      class="expandable-keyfigure__grid"
      :class="gridClass"
      :style="{ backgroundColor: content.backgroundColor || '#ffffff' }"
    >
      <article
        v-for="(card, index) in content.expandableColumnCards"
        :key="index"
        class="keyfigure-card"
      >
        <!-- IMAGE -->
        <img
          class="keyfigure-card__image"
          :src="card.cardImageUrl"
          :alt="card.cardImageAlt || ''"
        />

        <!-- TITLE -->
        <h3
          class="keyfigure-card__title halesworth"
          role="button"
          tabindex="0"
          :aria-expanded="expandedIndexes.includes(index)"
          :aria-controls="`card-title-${index}`"
          @click="toggleCard(index)"
          @keydown.enter="toggleCard(index)"
        >
          {{ truncate(card.cardTitle, 50) }}
        </h3>

        <!-- PRIMARY CTA-->
        <button
          v-if="!expandedIndexes.includes(index)"
          class="keyfigure-card__primary-cta"
          :aria-expanded="expandedIndexes.includes(index)"
          @click="handlePrimaryCta(card, index)"
          @keydown.enter="handlePrimaryCta(card, index)"
        >
          {{ formatCta(card.primaryCTAText) }}
        </button>

        <!-- DESCRIPTION -->

        <p
          v-if="expandedIndexes.includes(index)"
          role="button"
          tabindex="0"
          class="keyfigure-card__description"
          @click="toggleCard(index)"
          @keydown.enter="toggleCard(index)"
        >
          {{ truncate(card.cardDescription, 300) }}
        </p>

        <!-- SECONDARY CTA -->
        <button
          v-if="card.secondaryCTAText && expandedIndexes.includes(index)"
          class="keyfigure-card__secondary-cta"
          tabindex="0"
          @click="handleSecondaryCta(card, index)"
          @keydown.enter="handleSecondaryCta(card, index)"
        >
          {{ formatCta(card.secondaryCTAText) }}
        </button>
      </article>
    </div>
  </section>
</template>

<script>
export default {
  name: 'expandable-key-figure-card',

  props: {
    dataExpandableKeyFigureContent: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      expandedIndexes: [],
    };
  },

  computed: {
    content() {
      return this.dataExpandableKeyFigureContent || {};
    },
    cardCount() {
      if (
        this.content &&
        this.content.expandableColumnCards &&
        this.content.expandableColumnCards.length
      ) {
        return this.content.expandableColumnCards.length;
      }
      return 0;
    },

    gridClass() {
      return `cards-${this.cardCount}`;
    },
  },

  methods: {
    pushToDataLayer(payload) {
      if (!payload) return;
      if (!Array.isArray(window.dataLayer)) return;
      window.dataLayer.push(payload);
    },
    handlePrimaryCta(card, index) {
      this.pushToDataLayer(card.primaryCtaTaggingAttributes);
      this.toggleCard(index);
    },

    removeExpandedIndex(index) {
      const position = this.expandedIndexes.indexOf(index);
      if (position > -1) {
        this.expandedIndexes.splice(position, 1);
      }
    },

    handleSecondaryCta(card, index) {
      this.pushToDataLayer(card.secondaryCtaTaggingAttributes);
      if (card.secondaryCTAURL) {
        window.open(card.secondaryCTAURL, '_blank', 'noopener');
        return;
      }
      this.removeExpandedIndex(index);
    },

    toggleCard(index) {
      if (this.expandedIndexes.includes(index)) {
        this.removeExpandedIndex(index);
      } else {
        this.expandedIndexes.push(index);
      }
    },

    truncate(text, limit) {
      if (!text) return '';
      return text.length > limit ? text.slice(0, limit) + '…' : text;
    },

    formatCta(text) {
      return (text || '').slice(0, 12);
    },
  },
};
</script>
